module.exports = "/lucky-balls/img/bonus_yellow/check_infoBar/check_009.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bonus_yellow/check_infoBar/check_009.png
// module id = 954
// module chunks = 0